import {Injectable} from "@angular/core";

@Injectable()
export abstract class OrderLocal {
    public abstract getLastOrderCode(): number | null;
    public abstract setLastOrderCode(orderCode: number): void;
}